import React from 'react';

import { Card } from 'ui-components/components/card';
import { FlexColumn } from 'ui-components/components/flex';
import { ResponsiveWidth } from 'ui-components/components/responsive-layout';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import { PhoneContactRow } from './phone-contact-row';

export const SellerCommunicationSection = () => {
  return (
    <FlexColumn responsiveWidth={ResponsiveWidth.Cols9}>
      <Text textType={TextType.H3} value={messages.sellerCommunicationSubheader} />
      <Card>
        <PhoneContactRow />
      </Card>
    </FlexColumn>
  );
};
